import { AuthError, JwtSignature } from '../models';

// Avoid TS error "cannot find name escape"
declare const escape: Function;
declare const unescape: Function;

export const JwtUtil = {
  fromBase64: (base64url: string): Buffer | string => {
    let base64 = base64url
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    switch (base64.length % 4) {
      case 0: break;
      case 2: base64 += '=='; break;
      case 3: base64 += '='; break;
      default: throw new Error('Illegal base64url string "' + base64url + '"');
    }

    if (typeof Buffer === 'function') {
      return Buffer.from(base64, 'base64');
    }

    return decodeURIComponent(unescape(window.atob(base64)));
  },

  base64: (input: string | Object | Buffer): string => {
    let base64 = null;

    if (typeof Buffer === 'function') {
      if (typeof input === 'string') {
        base64 = Buffer.from(input, 'utf8').toString('base64');
      } else if (input instanceof Buffer) {
        base64 = input.toString('base64');
      } else {
        base64 = Buffer.from(JSON.stringify(input), 'utf8').toString('base64');
      }
    } else {
      const plainText = ( typeof input === 'string' ? input : JSON.stringify(input) ) as string;

      base64 = window.btoa(escape(encodeURIComponent(plainText)));
    }

    return base64
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  },

  parse(token: string): JwtSignature {
    const parts = token.split('.');

    if (parts.length !== 3 || parts[2].trim() === '') {
      throw new TypeError('Malformed JWT');
    }

    const payloadJson = JwtUtil.fromBase64( parts[1] ).toString();

    if (!payloadJson) {
      throw new Error('Cannot decode the token');
    }

    const payload = JSON.parse(payloadJson) as JwtSignature;
    const now = Math.floor(Date.now() / 1000);

    if (!payload || !payload.user || !payload.user.id) {
      throw new AuthError('Token is missing user');
    }

    if (typeof payload.exp !== 'number' || now >= payload.exp) {
      throw new AuthError('JWT has expired');
    }

    return payload;
  },

  expiration(token: string): Date {
    const payload = JwtUtil.parse(token);

    return new Date(payload.exp * 1000);
  }
};



// WEBPACK FOOTER //
// ./src/gs-core/common/auth/JwtUtil.ts